import { apiService } from '@/services/APIService';

export default {

  getChildren(params) {
    return apiService.get('/gifted-children', params);
  },

  // Экспорт таблицы детей
  downloadExcel(params) {
    return apiService.post('/gifted-children/export', params);
  },

  // Экспорт детей с детализацией ({ name, region_id, municipality_id } --> { type: 15 })
  downloadDetailedExcel(params) {
    return apiService.post('/gifted-children/export-event', params);
  },
};
